import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { useIdentity } from '../../../features/auth/useAuth';
import { SoloDashboard } from '../../../features/dashboard/SoloDashboard';

export const Route = createFileRoute('/$lang/app/')({ component: Dashboard });

function Dashboard(): ReactNode {
  const { lang } = Route.useParams();
  const { identity } = useIdentity();

  /* The `/app` guard guarantees an identity; this satisfies the type, not the logic. */
  if (identity === null) return null;

  return <SoloDashboard lang={lang} identity={identity} />;
}
